import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "atencao-empty"
}
const _hoisted_2 = { class: "prio-summary" }
const _hoisted_3 = { class: "prio-total-count" }
const _hoisted_4 = {
  key: 0,
  class: "prio-group"
}
const _hoisted_5 = { class: "prio-group-head" }
const _hoisted_6 = { class: "prio-group-label" }
const _hoisted_7 = { class: "prio-group-count" }
const _hoisted_8 = { class: "prio-grid" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "prio-contact" }
const _hoisted_12 = { class: "prio-name" }
const _hoisted_13 = {
  key: 0,
  class: "prio-phone"
}
const _hoisted_14 = { class: "prio-id" }
const _hoisted_15 = { class: "prio-card-body" }
const _hoisted_16 = { class: "prio-row" }
const _hoisted_17 = { class: "prio-row" }
const _hoisted_18 = { class: "prio-pills" }
const _hoisted_19 = { class: "ch-pill" }
const _hoisted_20 = {
  key: 0,
  class: "prio-wait"
}
const _hoisted_21 = { class: "prio-created" }
const _hoisted_22 = {
  key: 1,
  class: "prio-labels"
}
const _hoisted_23 = { class: "prio-card-foot" }
const _hoisted_24 = ["onClick"]

import { computed, watchEffect } from 'vue'
import type { Conversation } from '@/types/dashboard'
import { avatarColor, initials, fmtWait, fmtChannel } from '@/composables/useHelpers'
import { requestOpenChat } from '@/composables/useChatTrigger'

type PriorityKey = 'urgent' | 'high' | 'medium' | 'low'


export default /*@__PURE__*/_defineComponent({
  __name: 'PrioridadesTab',
  props: {
    conversations: {},
    active: { type: Boolean }
  },
  emits: ["updateBadge"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const PRIORITY_ORDER: PriorityKey[] = ['urgent', 'high', 'medium', 'low']
const PRIORITY_LABELS: Record<PriorityKey, string> = {
  urgent: 'Urgente',
  high: 'Alta',
  medium: 'Média',
  low: 'Baixa',
}
const PRIORITY_COLORS: Record<PriorityKey, string> = {
  urgent: '#dc2626',
  high: '#ea580c',
  medium: '#ca8a04',
  low: '#2563eb',
}

const withPriority = computed(() =>
  props.conversations.filter(c =>
    c.status !== 'resolved' && c.priority && c.priority !== 'none'
  )
)

const groups = computed(() =>
  PRIORITY_ORDER.map(key => ({
    key,
    label: PRIORITY_LABELS[key],
    color: PRIORITY_COLORS[key],
    convs: withPriority.value.filter(c => c.priority === key),
  }))
)

const total = computed(() => withPriority.value.length)

watchEffect(() => emit('updateBadge', total.value))

function statusLabel(s: string): string {
  const map: Record<string, string> = { open: 'Aberta', resolved: 'Resolvida', pending: 'Pendente' }
  return map[s] || s
}

function waitInfo(c: Conversation) {
  return fmtWait(c.waiting_since)
}

function fmtDate(ts: number): string {
  if (!ts) return '—'
  return new Date(ts * 1000).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-pane prio-pane", { hidden: !__props.active }])
  }, [
    (!total.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "8",
              x2: "12",
              y2: "12"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "16",
              x2: "12.01",
              y2: "16"
            })
          ], -1),
          _createElementVNode("p", null, "Sem prioridades definidas", -1),
          _createElementVNode("small", null, "Conversas com prioridade aparecerão aqui ordenadas por urgência.", -1)
        ]))]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10"
                }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "8",
                  x2: "12",
                  y2: "12"
                }),
                _createElementVNode("line", {
                  x1: "12",
                  y1: "16",
                  x2: "12.01",
                  y2: "16"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(total.value) + " conversa" + _toDisplayString(total.value !== 1 ? 's' : '') + " com prioridade ", 1)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: group.key
            }, [
              (group.convs.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", {
                        class: "prio-group-dot",
                        style: _normalizeStyle({ background: group.color })
                      }, null, 4),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(group.label), 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(group.convs.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.convs, (c) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: c.id,
                          class: "prio-card"
                        }, [
                          _createElementVNode("div", {
                            class: "prio-card-badge",
                            style: _normalizeStyle({ background: group.color + '22', color: group.color, borderColor: group.color + '55' })
                          }, [
                            _createElementVNode("span", {
                              class: "prio-card-dot",
                              style: _normalizeStyle({ background: group.color })
                            }, null, 4),
                            _createTextVNode(" " + _toDisplayString(group.label), 1)
                          ], 4),
                          _createElementVNode("div", {
                            class: "prio-card-head",
                            style: _normalizeStyle({ background: `linear-gradient(135deg, ${group.color}12 0%, var(--white) 60%)` })
                          }, [
                            _createElementVNode("div", {
                              class: "prio-av",
                              style: _normalizeStyle({ background: _unref(avatarColor)(c.contact.name) })
                            }, [
                              (c.contact.thumbnail)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: c.contact.thumbnail,
                                    alt: c.contact.name,
                                    style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%","display":"block"},
                                    onError: _cache[0] || (_cache[0] = (e) => (e.target as HTMLImageElement).style.display='none')
                                  }, null, 40, _hoisted_9))
                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(initials)(c.contact.name)), 1))
                            ], 4),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(c.contact.name), 1),
                              (c.contact.phone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(c.contact.phone), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_14, "#" + _toDisplayString(c.id), 1)
                          ], 4),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[3] || (_cache[3] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path></svg>", 1)),
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'prio-muted': !c.team })
                              }, _toDisplayString(c.team?.name || 'TypeBot'), 3)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "7",
                                  r: "4"
                                })
                              ], -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'prio-muted': !c.assignee })
                              }, _toDisplayString(c.assignee?.name || '— sem agente'), 3)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["status-pill", c.status])
                              }, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sdot" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(statusLabel(c.status)), 1)
                              ], 2),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(fmtChannel)(c.channel)), 1)
                            ]),
                            (waitInfo(c).cls !== 'none')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["wait-badge", waitInfo(c).cls])
                                  }, [
                                    _cache[6] || (_cache[6] = _createElementVNode("svg", {
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "10"
                                      }),
                                      _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(waitInfo(c).label), 1)
                                  ], 2)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, [
                              _cache[7] || (_cache[7] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line></svg>", 1)),
                              _createElementVNode("span", null, _toDisplayString(fmtDate(c.created_at)), 1)
                            ]),
                            (c.labels.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.labels, (lbl) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: lbl,
                                      class: "label-chip"
                                    }, _toDisplayString(lbl.replace(/-|_/g, ' ')), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("button", {
                              class: "prio-chat-btn",
                              onClick: ($event: any) => (_unref(requestOpenChat)(c.id))
                            }, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                              ], -1),
                              _createTextVNode(" Ver Conversa ", -1)
                            ]))], 8, _hoisted_24)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
  ], 2))
}
}

})